import React, { useState, useEffect } from "react";
import axios from "axios";
import { createMRTColumnHelper } from "material-react-table";
import Chip from "@mui/material/Chip";
import CustomTable from "../../../../components/custom_table/CustomTable";
import { baseUrl } from "../../../../helper/urls";
import {
  Box,
  Button,
  IconButton,
  Modal,
  TextField,
  Tooltip,
} from "@mui/material";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PreviewIcon from "@mui/icons-material/Preview";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
const CompletedBookings = () => {
  const { token } = useSelector((state) => state.auth);
  const [completeBookings, setCompleteBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCompleteBookings = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/bookings/getBookingCompletedCounselor`,
        { headers }
      );

      const data = response.data.data || [];

      // Add formattedReqId here
      const processedData = data.map((item) => ({
        ...item,
        formattedReqId: `DDR000${item.reqId || ""}`,
        studentName: `${item.firstName || ""} ${item.lastName || ""}`.trim(),
      }));

      setCompleteBookings(processedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      // setError("Failed to fetch bookings");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompleteBookings();
  }, []);

   function formatUtcTimeTo12Hour(timeStr) {
    if (!timeStr) return "N/A";
    const d = new Date(timeStr);
    let h = d.getUTCHours(), m = d.getUTCMinutes(), s = d.getUTCSeconds();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} ${ampm}`;
  }

  function formatUtcTimeTo12HourAdd1hour(timeStr) {
    if (!timeStr) return "N/A";
    const d = new Date(timeStr);
    d.setUTCHours(d.getUTCHours() + 1); // Add 1 hour
    let h = d.getUTCHours(), m = d.getUTCMinutes(), s = d.getUTCSeconds();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} ${ampm}`;
  }

  const getTimeZoneAbbreviation = () => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return moment.tz(timeZone).format("z");
  };
  const timeZoneAbbreviation = getTimeZoneAbbreviation();
    const convertSlotsToStudentTimezone1 = (utcTime, type, duration = 60) => {
      if (!utcTime || !type) return "Invalid input";
  
      const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const startLocal = moment.utc(utcTime).tz(studentTimeZone);
      const tzAbbr = startLocal.format("z"); 
      console.log('clllllllll',studentTimeZone,tzAbbr)
      const endLocal = moment(startLocal).add(duration, "minutes");
  
      switch (type) {
        case "date":
          return startLocal.format("YYYY-MM-DD");
        case "start":
          return startLocal.format("hh:mm:ss A");
        case "end":
          return endLocal.format("hh:mm:ss A");
        default:
          return "Invalid type";
      }
    };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const rowId = cell.row.original.id;
        const summary = cell.row.original.summary;
        return (
          <Box>
            {summary == null || summary.length == 0 ? (
              <Tooltip title="Upload Session Summary">
                <IconButton
                  color="success"
                  onClick={() => {
                    handleOpen();
                    setid(rowId);
                  }}
                >
                  <PostAddIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="View Session Summary">
                <IconButton
                  color="success"
                  onClick={() => {
                    handleOpenSummary();
                    setrowSummary(summary);
                  }}
                >
                  <PreviewIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    }),
    columnHelper.accessor("studentName", {
      header: "Student Name",
    }),

    columnHelper.accessor("booking_date", {
      header: "Slot Date (UTC)",
      // Cell: (cell) => {
      //   const date = cell.row.original?.booking_date;
      //   return date ? new Date(date).toLocaleDateString("en-IN") : "N/A";
      // },
      Cell: (cell) => cell.row.original.utcTime?.split("T")[0] || "N/A",
    }),
    columnHelper.accessor("start_time", {
      header: "Start Time (UTC)",
      // Cell: (cell) => cell.row.original?.start_time || "-",
      Cell: (cell) => formatUtcTimeTo12Hour(cell.row.original.utcTime),

    }),

    columnHelper.accessor("end_time", {
      header: "End Time (UTC)",
      // Cell: (cell) => cell.row.original?.end_time || "-",
      Cell: (cell) => formatUtcTimeTo12HourAdd1hour(cell.row.original.utcTime),

    }),
     columnHelper.accessor("booking_date", {
        id: "booking_date_local",
      header: `Slot Date (${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.booking_date?.split("T")[0],
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime,"date"),
    }),
    columnHelper.accessor("start_time", {
       id: "start_time_local",
      header: `Start time (${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.start_time || "--",
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime,"start"),
    }),
    columnHelper.accessor("end_time", {
       id: "end_time_local",
      header: `End time(${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.end_time || "--",
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime,"end"),
    }),

    // columnHelper.accessor("created_at", {
    //   header: "Created At",
    //   size: 30,
    //   Cell: (cell) => {
    //     const rawDate = cell.row.original?.created_at;
    //     if (!rawDate) return "N/A";

    //     const dateObj = new Date(rawDate);
    //     const day = String(dateObj.getDate()).padStart(2, "0");
    //     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    //     const year = dateObj.getFullYear();

    //     return `${day}-${month}-${year}`;
    //   },
    // }),
    columnHelper.accessor("formattedReqId", {
      header: "Request ID",
    }),
  ];
  const [id, setid] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [summary, setSummary] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async () => {
    if (!summary.trim()) {
      setError(true);
      // toast.error("Summary cannot be empty.");
      return;
    }

    setError(false);
    setSubmitting(true);

    try {
      await axios.post(
        `${baseUrl}/bookings/updateSummary/${id}`,
        { summary },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchCompleteBookings();
      toast.success("Summary updated successfully!");
      handleClose(); // Optional
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Failed to update summary.");
    } finally {
      setSubmitting(false);
    }
  };

  const [openSummary, setOpenSummary] = React.useState(false);
  const handleOpenSummary = () => setOpenSummary(true);
  const handleCloseSummary = () => setOpenSummary(false);
  const [rowSummary, setrowSummary] = useState("");

  return (
    <>
      <ToastContainer />
      <CustomTable
        columns={columns}
        data={completeBookings}
        loading={loading}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            border: "1px solid #fff",
            boxShadow: 24,
            p: 3,
          }}
        >
          <TextField
            label="Upload Session Summary"
            multiline
            minRows={8}
            fullWidth
            required
            value={summary}
            onChange={(e) => setSummary(e.target.value)}
            error={error && !summary.trim()}
            helperText={error && !summary.trim() ? "Summary is required." : ""}
            variant="outlined"
            sx={{
              borderRadius: 2,
              backgroundColor: "#fff",
            }}
          />

          <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
            <Button variant="contained" color="error" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleSubmit}
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit Summary"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openSummary}
        onClose={handleCloseSummary}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            border: "1px solid #fff",
            boxShadow: 24,
            p: 3,
          }}
        >
          <Box>{rowSummary}</Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              color="error"
              onClick={handleCloseSummary}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CompletedBookings;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { createMRTColumnHelper } from "material-react-table";
// import Chip from "@mui/material/Chip";
// import CustomTable from "../../../../components/custom_table/CustomTable";
// import { baseUrl } from "../../../../helper/urls";
// import {
//   Box,
//   Button,
//   IconButton,
//   Modal,
//   TextField,
//   Tooltip,
// } from "@mui/material";
// import PostAddIcon from "@mui/icons-material/PostAdd";
// import PreviewIcon from "@mui/icons-material/Preview";
// import { toast } from "react-toastify";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useSelector } from "react-redux";
// const CompletedBookings = () => {
//   const { token } = useSelector((state) => state.auth);
//   const [completeBookings, setCompleteBookings] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchCompleteBookings = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/bookings/getBookingCompletedCounselor`,
//         { headers }
//       );
//       setCompleteBookings(response.data.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching bookings:", error);
//       // setError("Failed to fetch bookings");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCompleteBookings();
//   }, []);

//   const columnHelper = createMRTColumnHelper();
//   const columns = [
//     columnHelper.accessor("actions", {
//       header: "Actions",
//       Cell: ({ cell }) => {
//         const rowId = cell.row.original.id;
//         const summary = cell.row.original.summary;
//         return (
//           <Box>
//             {summary == null || summary.length == 0 ? (
//               <Tooltip title="Upload Session Summary">
//                 <IconButton
//                   color="success"
//                   onClick={() => {
//                     handleOpen();
//                     setid(rowId);
//                   }}
//                 >
//                   <PostAddIcon />
//                 </IconButton>
//               </Tooltip>
//             ) : (
//               <Tooltip title="View Session Summary">
//                 <IconButton
//                   color="success"
//                   onClick={() => {
//                     handleOpenSummary();
//                     setrowSummary(summary);
//                   }}
//                 >
//                   <PreviewIcon />
//                 </IconButton>
//               </Tooltip>
//             )}
//           </Box>
//         );
//       },
//     }),
//     columnHelper.accessor("firstName", {
//       header: "Student Name",
//       Cell: (cell) =>
//         `${cell.row.original.firstName || ""} ${
//           cell.row.original.lastName || ""
//         }`,
//     }),

//     columnHelper.accessor("booking_date", {
//       header: "Slot Date",
//       Cell: (cell) => {
//         const date = cell.row.original?.booking_date;
//         return date ? new Date(date).toLocaleDateString("en-IN") : "N/A";
//       },
//     }),
//     columnHelper.accessor("start_time", {
//       header: "Start Time",
//       Cell: (cell) => cell.row.original?.start_time || "-",
//     }),

//     columnHelper.accessor("end_time", {
//       header: "End Time",
//       Cell: (cell) => cell.row.original?.end_time || "-",
//     }),

//     // columnHelper.accessor("created_at", {
//     //   header: "Created At",
//     //   size: 30,
//     //   Cell: (cell) => {
//     //     const rawDate = cell.row.original?.created_at;
//     //     if (!rawDate) return "N/A";

//     //     const dateObj = new Date(rawDate);
//     //     const day = String(dateObj.getDate()).padStart(2, "0");
//     //     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//     //     const year = dateObj.getFullYear();

//     //     return `${day}-${month}-${year}`;
//     //   },
//     // }),
//     columnHelper.accessor("reqId", {
//       header: "Request ID",
//       Cell: (cell) => "DDR000" + cell.row.original?.reqId || "-",
//     }),
//   ];
//   const [id, setid] = useState("");
//   const [open, setOpen] = React.useState(false);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const [summary, setSummary] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState(false);

//   const handleSubmit = async () => {
//     if (!summary.trim()) {
//       setError(true);
//       // toast.error("Summary cannot be empty.");
//       return;
//     }

//     setError(false);
//     setSubmitting(true);

//     try {
//       await axios.post(
//         `${baseUrl}/bookings/updateSummary/${id}`,
//         { summary },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       fetchCompleteBookings();
//       toast.success("Summary updated successfully!");
//       handleClose(); // Optional
//     } catch (error) {
//       console.error("Update failed:", error);
//       toast.error("Failed to update summary.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const [openSummary, setOpenSummary] = React.useState(false);
//   const handleOpenSummary = () => setOpenSummary(true);
//   const handleCloseSummary = () => setOpenSummary(false);
//   const [rowSummary, setrowSummary] = useState("");

//   return (
//     <>
//       <ToastContainer />
//       <CustomTable
//         columns={columns}
//         data={completeBookings}
//         loading={loading}
//       />
//       <Modal
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="modal-modal-title"
//         aria-describedby="modal-modal-description"
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 600,
//             bgcolor: "background.paper",
//             border: "1px solid #fff",
//             boxShadow: 24,
//             p: 3,
//           }}
//         >
//           <TextField
//             label="Upload Session Summary"
//             multiline
//             minRows={8}
//             fullWidth
//             required
//             value={summary}
//             onChange={(e) => setSummary(e.target.value)}
//             error={error && !summary.trim()}
//             helperText={error && !summary.trim() ? "Summary is required." : ""}
//             variant="outlined"
//             sx={{
//               borderRadius: 2,
//               backgroundColor: "#fff",
//             }}
//           />

//           <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
//             <Button variant="contained" color="error" onClick={handleClose}>
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               color="success"
//               onClick={handleSubmit}
//               disabled={submitting}
//             >
//               {submitting ? "Submitting..." : "Submit Summary"}
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//       <Modal
//         open={openSummary}
//         onClose={handleCloseSummary}
//         aria-labelledby="modal-modal-title"
//         aria-describedby="modal-modal-description"
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 600,
//             bgcolor: "background.paper",
//             border: "1px solid #fff",
//             boxShadow: 24,
//             p: 3,
//           }}
//         >
//           <Box>{rowSummary}</Box>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               mt: 2,
//             }}
//           >
//             <Button
//               variant="contained"
//               color="error"
//               onClick={handleCloseSummary}
//             >
//               Cancel
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//     </>
//   );
// };

// export default CompletedBookings;
